import axios from 'axios';
import store from "@/store"

const environment = process.env.VUE_APP_ROOT_API;

const http = axios.create({
  baseURL: environment
});

http.interceptors.request.use(
  (config) => {
    const token = store.getters.token;
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    } else {
      // Garante que não vazem tokens de sessões anteriores se o objeto for reutilizado
      delete config.headers['Authorization'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {

    return response;
  },

  async (error) => {
    // Só encerra sessão em falha de autenticação real.
    // 403 com código de negócio (plano / e-mail) não deve forçar logout cego.
    const businessCode = error.response?.data?.code;
    if (
      error.response?.status === 401 ||
      (error.response?.status === 403 &&
        businessCode !== "PLAN_EXPIRED" &&
        businessCode !== "ACCOUNT_NOT_VERIFIED")
    ) {
      store.commit("logout");
    }

    const errorData = error.response?.data || error.response || error;

    // Se a API retornar erro de plano expirado, redireciona para planos —
    // exceto na página de pagamento, onde o usuário está renovando.
    if (errorData && errorData.code === 'PLAN_EXPIRED') {
      import('@/router').then((router) => {
        const path = router.default.currentRoute?.value?.path || '';
        if (path !== '/plans/pagamento') {
          router.default.push('/plans');
        }
      });
    }

    if (errorData && errorData.code === 'ACCOUNT_NOT_VERIFIED') {
      import('@/router').then((router) => {
        router.default.push('/sign-in');
      });
    }

    // Retorna o erro de forma que o SignIn.vue possa tratar mesmo se for uma resposta achatada do interceptor
    return Promise.reject(errorData);
  }
)

export default http;